import React from 'react';
import { IconType } from '../../__generated__/types';
import { SvgLockersSolid } from '../Icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { getIconByGraphQLName } from './resourceIcons';

export const getResourceIcon = (
  iconType: IconType | null | undefined,
  color: string,
  size?: number
): JSX.Element | null => {
  if (iconType === IconType.CRC_LOCKERS) {
    return <SvgLockersSolid color={color} size={size} />;
  }
  const fa = getIconByGraphQLName(iconType);
  if (fa) {
    return <FontAwesomeIcon icon={fa.icon as IconProp} style={{ color }} />;
  }
  return null;
};
